import $ from "dabbyjs/src/core/dabby/dabby.js";
import carousel from './carousel.js';
import media from './media.js';

export default () => {
	carousel($(".hub-carousel"));
	carousel($(".hub-slides"), false);
	media($(".hub__content video, .hub__content audio"));
}